var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Alarm Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DataGate-LP---Action-Buttons",
    transform: "translate(-1019.000000, -360.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Alarm-Settings",
    transform: "translate(1019.000000, 360.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,17.25 C9.31,17.25 8.75,16.69 8.75,16 C8.75,15.31 9.31,14.75 10,14.75 C10.69,14.75 11.25,15.31 11.25,16 C11.25,16.69 10.69,17.25 10,17.25 L10,17.25 Z M9,8 L11,8 L11,14 L9,14 L9,8 Z M19.895,18.553 L10.895,0.553 C10.556,-0.125 9.444,-0.125 9.105,0.553 L0.105,18.553 C-0.049,18.863 -0.033,19.231 0.149,19.526 C0.332,19.82 0.653,20 1,20 L19,20 C19.347,20 19.668,19.82 19.851,19.526 C20.033,19.231 20.049,18.863 19.895,18.553 L19.895,18.553 Z",
    id: "Fill-1905"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmSettings);
export default __webpack_public_path__ + "static/media/alarmSettings.034b928d2426a43d8a1fa22e378a76ad.svg";
export { ForwardRef as ReactComponent };